import { render } from "./MasterPage.vue?vue&type=template&id=7669abfa&scoped=true&ts=true"
import script from "./MasterPage.ts?vue&type=script&lang=ts"
export * from "./MasterPage.ts?vue&type=script&lang=ts"

import "./MasterPage.pcss?vue&type=style&index=0&id=7669abfa&scoped=true&lang=postcss"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7669abfa"]])

export default __exports__